import { AuthenticationDto } from "../dto/authentication-dto";
import { AuthenticationModel } from "../../models/authentication-model";

export class AuthenticationConverter {

  static convert(dto: AuthenticationDto): AuthenticationModel {
    return new AuthenticationModel(
      dto.statusCode,
      dto.data.issuer?.url || '',
      dto.data.issuer?.key || '',
      dto.userMessageTitle,
      dto.userMessageDesc,
      dto.data.retry
    );
  }

}